import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	disabledBox: {
		position: "relative",
		opacity: 0.5
	}
})

export default useStyles
